import { useEffect } from 'react';
import {
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  ListSubheader,
  Tooltip,
} from '@mui/material';

import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import GradingOutlinedIcon from '@mui/icons-material/GradingOutlined';
import TravelExploreOutlinedIcon from '@mui/icons-material/TravelExploreOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
// import TroubleshootOutlinedIcon from '@mui/icons-material/TroubleshootOutlined';
// import PersonSearchOutlinedIcon from '@mui/icons-material/PersonSearchOutlined';
import AppSidebarLayout from '../shared/AppSidebarLayout';
import { Outlet, useLocation, useNavigate } from 'react-router';

function Admin(): React.JSX.Element {
  const location = useLocation();
  const navigate = useNavigate();

  const app = location.pathname.split('/').at(-1);
  useEffect(() => {
    if (app === 'admin' || app === 'quartermaster') {
      navigate('/admin/manifests');
    }
  }, [app, navigate]);

  const NavMenuContent = (
    <>
      <List
        component='nav'
        subheader={
          <ListSubheader component='div' id='general-list-subheader'>
            General
          </ListSubheader>
        }
      >
        <ListItemButton
          selected={app === 'types'}
          onClick={() => {
            navigate('/admin/document/types');
          }}
        >
          <ListItemIcon>
            <CategoryOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Document Types' />
        </ListItemButton>
        <ListItemButton
          selected={app === 'documents'}
          onClick={() => {
            navigate('/admin/documents');
          }}
        >
          <ListItemIcon>
            <InsertDriveFileOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Documents' />
        </ListItemButton>
      </List>
      <List
        component='nav'
        subheader={
          <ListSubheader component='div' id='quartermaster-list-subheader'>
            Quartermaster
          </ListSubheader>
        }
      >
        <ListItemButton
          selected={app === 'global'}
          onClick={() => {
            navigate('/admin/global');
          }}
        >
          <ListItemIcon>
            <TravelExploreOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Global Checks' />
        </ListItemButton>
        <ListItemButton
          selected={app === 'manifests'}
          onClick={() => {
            navigate('/admin/manifests');
          }}
        >
          <ListItemIcon>
            <GradingOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary='Manifests' />
        </ListItemButton>
      </List>
      <List
        component='nav'
        subheader={
          <ListSubheader component='div' id='cartographer-list-subheader'>
            Cartographer
          </ListSubheader>
        }
      >
        <Tooltip title='Coming Soon' placement='right'>
          <span>
            <ListItemButton
              selected={app === 'charts'}
              onClick={() => {
                navigate('/admin/charts');
              }}
              disabled={import.meta.env.VITE_STAGE === 'prod'}
            >
              <ListItemIcon>
                <MapOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary='Charts' />
            </ListItemButton>
          </span>
        </Tooltip>
      </List>
    </>
  );

  return (
    <AppSidebarLayout
      headerTitle={'Administration'}
      HeaderIcon={FactCheckOutlinedIcon}
      SidebarContent={NavMenuContent}
    >
      <Outlet />
    </AppSidebarLayout>
  );
}

export default Admin;
